/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface BatteryEventOffsetEUMarker {
  size?: number,
  containerColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic with Offset for battery events of the asset
 *
 * ```typescript
 *  import {getBatteryEventOffsetEUMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getBatteryEventOffsetEUMarker({size, containerColor, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getBatteryEventOffsetEUMarker = ({
  fillColor = dlsColor('black'),
  containerColor = dlsColor('white'),
  size = 48
}: BatteryEventOffsetEUMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_434_165)'>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M11.8 13.2C5.83532 13.2 1 18.0353 1 24C1 29.9647 5.83532 34.8 11.8 34.8C17.7647 34.8 22.6 29.9647 22.6 24C22.5934 18.0381 17.762 13.2066 11.8 13.2Z' fill='#BDBDBD'/>
        <path fill-rule='evenodd' clip-rule='evenodd' d='M11.8 33C16.7705 33 20.8 28.9705 20.8 24C20.8 19.0294 16.7705 15 11.8 15C6.82944 15 2.8 19.0294 2.8 24C2.80557 28.9683 6.83175 32.9944 11.8 33Z' fill='${containerColor}'/>
        <mask id='mask0_434_165' style='mask-type:luminance' maskUnits='userSpaceOnUse' x='8' y='17' width='8' height='13'>
          <path d='M15.31 17.7009H8.2V29.5809H15.31V17.7009Z' fill='${containerColor}'/>
        </mask>
        <g mask='url(#mask0_434_165)'>
          <path d='M12.34 24.8109H11.17V21.3009H12.34V24.8109ZM12.34 27.2409H11.17V26.0709H12.34V27.2409ZM14.59 18.8709H13.6V17.7009H10V18.8709H9.01C8.56 18.8709 8.2 19.2309 8.2 19.6809V28.7709C8.2 29.2209 8.56 29.5809 9.01 29.5809H14.5C14.95 29.5809 15.31 29.2209 15.31 28.7709V19.6809C15.31 19.2309 14.95 18.8709 14.59 18.8709Z' fill='${fillColor}'/>
        </g>
      </g>
      <defs>
        <clipPath id='clip0_434_165'>
          <rect width='21.6' height='21.6' fill='${containerColor}' transform='translate(1 13.2)'/>
        </clipPath>
      </defs>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getBatteryEventOffsetEUMarker;
